import React, { useEffect } from "react";
import EventLoginForm from "./EventLoginForm";
import EventLoginCheckoutForm from "./EventLoginCheckoutForm";
import EventRegisterCheckoutForm from "./EventRegisterCheckoutForm";
import { useDispatch, useSelector } from "react-redux";
import EventGuestCheckoutForm from "./EventGuestCheckoutForm";
import axios from "axios";
import { resetTimer } from "../../app/features/timer/timerSlice";
import { store } from "../../app/store";

const EventLoginModal = () => {
  const user = useSelector((state) => state.user.user);
  const askSignup = useSelector((state) => state.user.askSignup);
  const userGuest = useSelector((state) => state.user.guest);
  const dispatch = useDispatch();

  useEffect(() => {
    const modalEl = document.getElementById("exampleModalToggle");

    const handleModalClose = async () => {
      const currentItems = store.getState().event.items; 
      const tickets = Object.values(currentItems).reduce((acc, el) => {
        if (el != null) {
          acc.push({
            ticket_id: el.ticket_id,
            quantity: el.quantity,
          });
        }
        return acc;
      }, []);

      await axios.request({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/api/unhold_tickets`,
        data: { tickets: tickets },
        headers: {
          Authorization: process.env.REACT_APP_API_KEY,
        },
      });
      dispatch(resetTimer());
    };

    modalEl.addEventListener("hidden.bs.modal", handleModalClose);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleModalClose);
    };
  }, []);
  return (
    <div>
      <div
        className={`modal fade`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        id="exampleModalToggle"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div
            className="modal-content"
            style={{ overflowY: "inherit !important" }}
          >
            <div className="row">
              <div className="col-12 d-flex justify-content-end p-4">
                <button
                  type="button"
                  id="close_modal"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
            </div>
            <div className="modal-body">
              {!user && !askSignup && !userGuest && <EventLoginForm />}
              {!user && !askSignup && userGuest && <EventGuestCheckoutForm />}
              {user && !askSignup && <EventLoginCheckoutForm />}
              {!user && askSignup && <EventRegisterCheckoutForm />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventLoginModal;
